export const API_URL = {
    'customer.all': '/crm/customer/all',
    'customer.store': '/crm/customer/store',
    'customer.confirmCustomerCreate': '/crm/customer/confirmCustomerCreate',
    'customer.confirmCustomerUpdate': '/crm/customer/:customer_id/confirmCustomerUpdate',
    'customer.updateContact': '/crm/customer/:customer_id/update-contact',
    'customer.update': '/crm/customer/:customer_id/update',
    'customer.info': '/crm/customer/:customer_id/info',
    'customer.delete': '/crm/customer/:customer_id/delete',
    'customer.block': '/crm/customer/block/:customer_id'
}
